import Button from '@/components/next-ui/Button';
import { isEmpty } from 'lodash-es';
import React from 'react';
import PostImageSelector from '../PostImageSelector/PostImageSelector';
import PostVideoSelector from '../PostVideoSelector/PostVideoSelector';

function AttachPostMedia(props) {
  const { type = 'image', assets, onChange } = props;
  const [selected, setSelected] = React.useState(assets || []);

  const handleChange = (data) => {
    setSelected(data);
  };

  return (
    <div className="flex w-full flex-col">
      <div className="flex flex-1 flex-col overflow-y-auto">
        {type === 'image' ? (
          <PostImageSelector value={selected} onChange={handleChange} />
        ) : (
          <PostVideoSelector value={selected} onChange={handleChange} />
        )}
      </div>
      <div className="flex w-full items-center justify-end gap-4 py-2">
        <Button
          color="primary"
          variant="outlined"
          size="md"
          onClick={() => onChange(isEmpty(assets) ? undefined : assets)}>
          Cancel
        </Button>
        <Button
          disabled={!selected}
          color="primary"
          variant="filled"
          size="md"
          onClick={() => onChange(selected)}>
          Done
        </Button>
      </div>
    </div>
  );
}

export default AttachPostMedia;
